function getUrlQuery(toSkip) {
    if (!toSkip)
        toSkip = []
    let urlQuery = '';
    for (let prop in this.$route.query) {
        if (toSkip.filter(x => x === prop).length === 0)
            urlQuery += prop + '=' + this.$route.query[prop] + '&'
    }
    return urlQuery.substr(0,urlQuery.length - 1);
}

export {getUrlQuery}